
import { useRef } from 'react';
import { Space, Table, Button, Input,Switch,Upload ,message,Select,Empty } from 'antd';
import type { TableProps,UploadProps } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import ProductItem from './components/productsEdit';
import { DataType, column } from './column';
import { productList,changeStatusProduct,importTemplate,importProduct } from '@/services/product';
import { ResDataType } from '@/services/ajax';
import useSearchTable from '@/hooks/useList';
import MenuPermissionControl from '@/components/menuPermissionControl';
import useGetCurMenuId from '@/hooks/useGetCurMenuId';

export default function ProductsPage() {
  const { menuId } = useGetCurMenuId();
  const dialog = useRef<any>(null);
  const defaultValue = {
    ProductName: '',
    Status: '',
  }
  const {
    data,
    total,
    loading,
    fetchData,
    searchParams,
    handleSearch,
    handlePageChange
  } = useSearchTable(productList, defaultValue );
  
  const search = (e:any,field:string)=>{
    handleSearch({[field]: e.target.value})
  }

  const columns: TableProps<DataType>['columns'] = [
    ...(column || []),
    //  {
    //    title: '权益状态',
    //    dataIndex: 'status',
    //    key: 'status',
    //    render: (_, record) => (
    //      <Tag color={record.status == 0 ? 'green' : 'red'}>
    //        {record.status == 0 ? '上架' : '下架'}
    //      </Tag>
    //    )
    //  },
     {
       title: '操作',
       key: 'action',
       fixed: 'right',
       render: (_, record) => (
        <MenuPermissionControl menuId={menuId} operation="edit" >
          <Space size="middle">
            <Button disabled={record.status == 0} onClick={()=>{
              openDialog('edit',record)
            } }>编辑</Button>
            {/* <Popconfirm
              title="提示"
              description="确定删除该商品吗?"
              onConfirm={()=> deletePro(record.id)}
              okText="确定"
              cancelText="取消"
            >
              <Button danger>删除</Button>
            </Popconfirm> */}
            <Switch checkedChildren="已上架" unCheckedChildren="已下架" onChange={(e)=>{
              handleChangeStatus(record.id,e?0:1)
            }} checked={record.status == 0 ? true : false}  />
          </Space>
         </MenuPermissionControl>
       ),
     },
   ];


   const openDialog = (type:string,record?:DataType) => {
     dialog.current?.open(type,record);
   }

   const handleChangeStatus = async (productId:number,status:number) => {
     const res = await changeStatusProduct({productId,status}) as ResDataType;
     if (res.code != 0) {
       message.error(res.message);
       return;
     }
     handleSearch();
   }

   const getImportTemplate = async () => {
    const res = await importTemplate() as ResDataType;
    if (res.code!= 0) {
      message.error(res.message);
      return;
    }
    window.open(`${res.data}`, '_blank');
   }

   const uploadProps = {
      name: 'file',
      multiple: false,
      showUploadList: false,
      customRequest: ({ file, onSuccess, onError, onProgress }:any) => {
        const formData = new FormData();
        formData.append('File', file);
        importProduct(formData).then((res:any)=> {
          onSuccess(res.data);
          if (res.code == 0) {
            message.success('导入成功')
            handleSearch();
          } else {
            message.error(res.message);
          }
        }).catch((err:any)=> {
          onError(err);
          message.error('导入失败');}) 
      },
    };
 
 return (
   <>
     <div className="headerTitle">
       <div>
         <h2>权益管理</h2>
       </div>
       
     </div>

     <div className="card m-6">
       <div className="searchCond">
         <Space size='middle'>
           <Input style={{ width:'250px' }} allowClear placeholder="权益名称"  onPressEnter={(e)=> search(e,'ProductName') } size='large' onChange={(e) => search(e,'ProductName')}/>
           
            <Select
              id='value'
              size='large'
              defaultValue=""
              style={{ width: 120 }}
              onChange={(e)=> handleSearch({Status: e})}
              options={[
                { key: 'all', value: '', label: '所有状态' },
                { key: 'up', value: 0, label: '上架' },
                { key: 'down',value: 1, label: '下架' }
              ]}
            />
            <Button type="primary" size='large' onClick={()=>{ fetchData() }}>搜索</Button>
            
          <MenuPermissionControl menuId={menuId} operation="edit" >
            <Button type="primary" size='large' onClick={()=> openDialog('add')}>
              添加权益
            </Button>
          </MenuPermissionControl>
          <MenuPermissionControl menuId={menuId} operation="edit" >
            <Space size="middle">
            <Button type="primary" size='large' onClick={()=>{ getImportTemplate() }}>获取权益导入模板</Button>

              <Upload {...uploadProps}>
                <Button type="primary" size='large' icon={<UploadOutlined />}  >导入</Button>
              </Upload>
            </Space>
            </MenuPermissionControl>
         {/* <Button type="primary" size='large' >导入</Button> */}
         </Space>
       </div>

       <div className="overflow-x-auto">
         <Table<DataType>
         rowKey='id'
         columns={columns} 
         dataSource={data as DataType[]}
         loading={loading}
         pagination={{ current: searchParams.PageIndex, pageSize:searchParams.PageSize, total, onChange: handlePageChange ,showSizeChanger:false  }}
         scroll={{ x: 'max-content', y: 580 }}
         locale={{ emptyText: <Empty description="暂无数据"></Empty> }}
         />
       </div>
     </div>
     <ProductItem ref={dialog} save={handleSearch}/>
   </>
 );
} 